import { render } from "./Create.vue?vue&type=template&id=1cb93b6b&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=1cb93b6b&lang=scss&scoped=true"
import "./Create.vue?vue&type=style&index=1&id=1cb93b6b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb93b6b"]])

export default __exports__